import { render } from "./DataIbuHamil.vue?vue&type=template&id=5bc80652"
import script from "./DataIbuHamil.vue?vue&type=script&lang=js"
export * from "./DataIbuHamil.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__